export enum FunctionalType {
  Traction = "Traccion",
  Thrust = "empuje",
}
